import { Node, mergeAttributes, RawCommands } from "@tiptap/core";
import { GraphMetadata, createGraphNodeView } from "./tiptap-graph-node-view";
import { readGraphHeight } from '../content-creator/graph-model';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    graphComponent: {
      openGraphEditor: (attrs: GraphMetadata) => ReturnType;
    }
  }
  // Add this block:
  interface Storage {
    graphComponent: {
      onEdit: (attrs: GraphMetadata) => void;
    }
  }
}

export const GraphNode = Node.create({
  name: 'graphComponent',
  group: 'block',
  atom: true,

  addOptions() {
    return {
      onEdit: (attrs: GraphMetadata) => {
        console.warn('onEdit not implemented', attrs);
      },
    };
  },

  addAttributes() {
    return {
      height: {
        default: null,
        parseHTML: element => readGraphHeight(element.getAttribute('data-height')),
        renderHTML: attributes => {
          const height = readGraphHeight(attributes.height);
          return height === null ? {} : { 'data-height': String(height) };
        },
      },
      nodesJson: { 
        default: '[]',
        parseHTML: element => element.getAttribute('data-nodes') || '[]',
        renderHTML: attributes => ({ 'data-nodes': attributes.nodesJson }),
      },
      edgesJson: { 
        default: '[]',
        parseHTML: element => element.getAttribute('data-edges') || '[]',
        renderHTML: attributes => ({ 'data-edges': attributes.edgesJson }),
      },
      examplesJson: { 
        default: '{}',
        parseHTML: element => element.getAttribute('data-examples') || '{}',
        renderHTML: attributes => ({ 'data-examples': attributes.examplesJson }),
      },
    };
  },

  addStorage() {
    return {
      onEdit: (attrs: GraphMetadata) => {
        console.warn('onEdit not implemented');
      },
    };
  },

  addCommands() {
    return {
      openGraphEditor: (attrs: GraphMetadata) => ({ editor }) => {
        // Access via this.storage
        if (typeof this.storage.onEdit === 'function') {
          this.storage.onEdit(attrs);
          return true;
        }
        return false;
      },
    } as RawCommands;
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="graph-component"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div', 
      mergeAttributes(HTMLAttributes, { 
        'data-type': 'graph-component',
        class: 'graph-runtime-placeholder' 
      })
    ];
  },

  /**
   * Render directly in the editor iframe without requiring React EditorContent.
   */
  addNodeView() {
    return createGraphNodeView;
  },
});
